module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./PayMentView.js"));
	}, "payMentView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=payMentView!./src/pages/Promote/OfflineActivity/PayMent/PayMentView.js
// module id = 1176
// module chunks = 431